export default __webpack_public_path__ + "static/use@mob-e4a1ab819f95b39b02e9d88068891a92.jpg";